import React, { useState } from 'react';
import {
  Typography,
  Tab,
  Tabs
} from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import MainTabs from './mainTabs/MainTabs';
import Topics from './topics/Topics';
import SubTabs from './subTabs/SubTabs';


const HelpConfigurations = () => {
  const [activeTab, setActiveTab] = useState('0');

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y px-10 pb-25">
      <Typography variant="h3" className="mb-8">Help Page Configurations</Typography>
      <div>
        <TabContext value={activeTab}>
          <Tabs
            value={activeTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, value) => setActiveTab(value)}
          >
            <Tab
              className="capitalize font-medium"
              value="0"
              label="Main Category"
            />
            <Tab
              className="capitalize font-medium"
              value="1"
              label="Sub-Category"
            />
            <Tab
              className="capitalize font-medium"
              value="2"
              label="Topics"
            />
          </Tabs>
          <TabPanel value="0">
            <MainTabs />
          </TabPanel>
          <TabPanel value="1">
            <SubTabs />
          </TabPanel>
          <TabPanel value="2">
            <Topics />
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default HelpConfigurations;
